/***
 * @ngdoc directive
 * @name BB.bbTimeRangeStacked
 * @restrict E
 * @scope true
 *
 * @description
 *Loads a list of time range stacked for the currently in scope company
 *
 * Used for selecting multiple services for checkout
 *
 * NOTE: This directive does not replace bbTimeRanges and should be used in conjunction with bbTimeRanges.
 *
 * NOTE: adding this alone will not immediately enable multiple service selection
 * you will also need to use the bbMultiServiceSelect within the _service.html template
 * see bbMultiServiceSelect directive for more detail
 *
 * WARNING: this does not work well with booking multiple services which have pre and post times
 * pre and post times are not considered so bookings may overlap
 *
 * @param {hash}  bbTimeRangeStacked A hash of options
 * @property {date} start_date The start date of time range list
 * @property {date} end_date The end date of time range list
 * @property {integer} available_times The available times of range list
 * @property {object} day_of_week The day of week
 * @property {object} selected_day The selected day from the multi time range list
 * @property {object} original_start_date The original start date of range list
 * @property {object} start_at_week_start The start at week start of range list
 * @property {object} selected_slot The selected slot from multi time range list
 * @property {object} selected_date The selected date from multi time range list
 * @property {object} alert The alert service - see {@link BB:Alert Alert Service}
 */
angular.module('BBPublicBooking').directive('bbTimeRangeStacked', () => {
        return {
            controller: 'bbTimeRangeStackedController',
            controllerAs: '$bbTimeRangeStackedCtrl'
        };
    }
);



// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/public-booking/time-range-stacked/bb_time_range_stacked.directive.js